import React from 'react';
import { Button } from '../ui/button';
import { TableHead } from '../ui/table';
import { ArrowUp, ArrowDown, ChevronsUpDown } from 'lucide-react';

// Shared by every game_department report table: a sortable column header and
// the pager beneath it.

export function SortableHead({ col, label, sortCol, sortDir, onSort, right }) {
  const active = sortCol === col;
  const Icon = active ? (sortDir === 'asc' ? ArrowUp : ArrowDown) : ChevronsUpDown;
  return (
    <TableHead
      onClick={() => onSort(col)}
      className={`cursor-pointer select-none whitespace-nowrap hover:text-ink ${right ? 'text-right' : ''}`}
    >
      <span className={`inline-flex items-center gap-1 ${right ? 'flex-row-reverse' : ''}`}>
        {label}
        <Icon className={`h-3 w-3 shrink-0 ${active ? '' : 'opacity-40'}`} />
      </span>
    </TableHead>
  );
}

export function TablePagination({ page, totalPages, total, onPageChange, noun = 'game' }) {
  if (total === 0) return null;
  return (
    <div className="flex items-center justify-between mt-3">
      <span className="text-[11px] text-ink-dim">{total} {noun}{total === 1 ? '' : 's'}</span>
      <div className="flex items-center gap-2">
        <Button variant="ghost" size="sm" disabled={page <= 1} onClick={() => onPageChange(page - 1)}>← Prev</Button>
        <span className="text-[11px] text-ink-dim">{page} / {totalPages}</span>
        <Button variant="ghost" size="sm" disabled={page >= totalPages} onClick={() => onPageChange(page + 1)}>Next →</Button>
      </div>
    </div>
  );
}
